import {useEffect} from "react";

interface ISwipeEvent {
    delta: number;
}

interface IProps {
    element?: HTMLElement | null;
    onSwipeLeft?: (event: ISwipeEvent) => void;
    onSwipeRight?: (event: ISwipeEvent) => void;
    onSwipeUp?: (event: ISwipeEvent) => void;
    onSwipeDown?: (event: ISwipeEvent) => void;
    disableTouchScroll?: boolean;
    disable?: boolean;
}

export const useSwipe = (props: IProps) => {
    useEffect(() => {
        if (props.disable) {
            return;
        }

        let touchStartX = -1;
        let touchStartY = -1;
        let touchEndX = -1;
        let touchEndY = -1;

        const resetTouchValues = () => {
            touchStartX = -1;
            touchEndX = -1;
            touchStartY = -1;
            touchEndY = -1;
        };

        const onTouchStart = (event: TouchEvent) => {
            touchStartX = event.changedTouches[0].screenX;
            touchStartY = event.changedTouches[0].screenY;
        };

        const onTouchMove = (event: TouchEvent) => {
            touchEndX = event.changedTouches[0].screenX;
            touchEndY = event.changedTouches[0].screenY;
        };

        const onTouchMovePassive = (event: TouchEvent) => {
            if (props.disableTouchScroll) {
                event.preventDefault();
            }
        };

        const onTouchEnd = () => {
            if (touchStartX === -1 || touchEndX === -1 || touchStartY === -1 || touchEndY === -1) {
                resetTouchValues();
                return;
            }

            if (touchEndX < touchStartX) {
                props.onSwipeLeft?.({
                    delta: touchStartX - touchEndX
                });
            }
            if (touchEndX > touchStartX) {
                props.onSwipeRight?.({
                    delta: touchEndX - touchStartX
                });
            }
            if (touchEndY < touchStartY) {
                props.onSwipeUp?.({
                    delta: touchStartY - touchEndY
                });
            }
            if (touchEndY > touchStartY) {
                props.onSwipeDown?.({
                    delta: touchEndY - touchStartY
                });
            }

            resetTouchValues();
        };

        window.document.addEventListener("touchstart", onTouchStart, false);
        window.document.addEventListener("touchmove", onTouchMove, false);
        window.document.addEventListener("touchmove", onTouchMovePassive, {passive: false} as EventListenerOptions);
        window.document.addEventListener("touchend", onTouchEnd, false);

        return () => {
            window.document.removeEventListener("touchstart", onTouchStart);
            window.document.removeEventListener("touchmove", onTouchMove);
            window.document.removeEventListener("touchmove", onTouchMovePassive, {passive: false} as EventListenerOptions);
            window.document.removeEventListener("touchend", onTouchEnd);
        };
    }, [props.element, props.disable]);
};
import {useEffect} from "react";

interface ISwipeEvent {
    delta: number;
}

interface IProps {
    element?: HTMLElement | null;
    onSwipeLeft?: (event: ISwipeEvent) => void;
    onSwipeRight?: (event: ISwipeEvent) => void;
    onSwipeUp?: (event: ISwipeEvent) => void;
    onSwipeDown?: (event: ISwipeEvent) => void;
    disableTouchScroll?: boolean;
    disable?: boolean;
}

export const useSwipe = (props: IProps) => {
    useEffect(() => {
        if (props.disable) {
            return;
        }

        let touchStartX = -1;
        let touchStartY = -1;
        let touchEndX = -1;
        let touchEndY = -1;

        const resetTouchValues = () => {
            touchStartX = -1;
            touchEndX = -1;
            touchStartY = -1;
            touchEndY = -1;
        };

        const onTouchStart = (event: TouchEvent) => {
            touchStartX = event.changedTouches[0].screenX;
            touchStartY = event.changedTouches[0].screenY;
        };

        const onTouchMove = (event: TouchEvent) => {
            touchEndX = event.changedTouches[0].screenX;
            touchEndY = event.changedTouches[0].screenY;
        };

        const onTouchMovePassive = (event: TouchEvent) => {
            if (props.disableTouchScroll) {
                event.preventDefault();
            }
        };

        const onTouchEnd = () => {
            if (touchStartX === -1 || touchEndX === -1 || touchStartY === -1 || touchEndY === -1) {
                resetTouchValues();
                return;
            }

            if (touchEndX < touchStartX) {
                props.onSwipeLeft?.({
                    delta: touchStartX - touchEndX
                });
            }
            if (touchEndX > touchStartX) {
                props.onSwipeRight?.({
                    delta: touchEndX - touchStartX
                });
            }
            if (touchEndY < touchStartY) {
                props.onSwipeUp?.({
                    delta: touchStartY - touchEndY
                });
            }
            if (touchEndY > touchStartY) {
                props.onSwipeDown?.({
                    delta: touchEndY - touchStartY
                });
            }

            resetTouchValues();
        };

        window.document.addEventListener("touchstart", onTouchStart, false);
        window.document.addEventListener("touchmove", onTouchMove, false);
        window.document.addEventListener("touchmove", onTouchMovePassive, {passive: false} as EventListenerOptions);
        window.document.addEventListener("touchend", onTouchEnd, false);

        return () => {
            window.document.removeEventListener("touchstart", onTouchStart);
            window.document.removeEventListener("touchmove", onTouchMove);
            window.document.removeEventListener("touchmove", onTouchMovePassive, {passive: false} as EventListenerOptions);
            window.document.removeEventListener("touchend", onTouchEnd);
        };
    }, [props.element, props.disable]);
};
